// AI F §1.1.5 — the route name knowledge_base_index is stored in the "Knowledge Base" permission (frontend_routes)
import SettingsContent from '../Wrapper';
import Index from './Index';
import { frontendURL } from '../../../../helper/URLHelper';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/knowledge-base'),
      component: SettingsContent,
      props: {
        headerTitle: 'KNOWLEDGE_BASE.HEADER',
        icon: 'book',
        showNewButton: false,
      },
      children: [
        {
          path: '',
          name: 'knowledge_base_wrapper',
          roles: ['administrator', 'agent'],
          redirect: 'list',
        },
        {
          path: 'list',
          name: 'knowledge_base_index',
          roles: ['administrator', 'agent'],
          component: Index,
        },
      ],
    },
  ],
};
